import defaultState, { defaultPresenterState, defaultTrackState, RoomReducer } from './defaultState'
import * as actionTypes from '../../constants/actionTypes'
import * as trackActionTypes from '../../constants/actionTypes/tracks'
import { playInTypes } from '../../actions/playIns/playInTypes'
import { slidesTypes } from '../../actions/slides/slidesTypes'
import { actionTypes as webcastActionTypes } from '@bt-react/store'
import { ReduxAction } from '../reducerType'
import { debug } from '@bt-react/libs/Logger'
import { roomTypes } from '../../actions/room/roomTypes'
import { setupTypes } from '../../actions/setup/setupTypes'
import uniq from 'lodash/uniq'
import produce, { Draft } from 'immer'
import { GigTypes } from '../../actions/gig/gigTypes'
import { DocsType } from '../../actions/docs/docsTypes'

function amendTracks (state: RoomReducer, payload: any, changes: {}): RoomReducer['presenters'] {

  const { presenterSid, trackSid } = payload

  const presenters = new Map(state.presenters)
  const body = presenters.get(presenterSid)

  if (typeof body === 'undefined') return presenters

  const tracks = new Map(body.tracks)
  const track = tracks.get(trackSid) || { ...defaultTrackState }

  tracks.set(trackSid, {
    ...defaultTrackState,
    ...track,
    ...changes
  })

  presenters.set(presenterSid, {
    ...body,
    tracks
  })
  return presenters

}

export default function (state: RoomReducer = defaultState, { type, payload }: ReduxAction) {

  switch (type) {

    case actionTypes.TOKEN_SUCCESS:
      return { ...state, isFetchingRoom: true }
    case setupTypes.SET_ROOM:
      return { ...state, isFetchingRoom: false, room: payload, hasWebcamError: false }
    case roomTypes.TEAR_DOWN_ROOM_SUCCESS:
      return { ...defaultState }
    case roomTypes.PRESENTER_CONNECTED: {

      const presenters = new Map(state.presenters)
      // Should do the local check in a selector instead
      presenters.set(payload.sid, { ...defaultPresenterState, name: payload.identity, local: payload.local })

      return { ...state, presenters }

    }
    case roomTypes.PRESENTER_DISCONNECTED:
    {

      debug(`Remote disconnection`)

      const presenters = new Map(state.presenters)
      presenters.delete(payload)

      return { ...state, presenters }

    }
    case trackActionTypes.SET_TRACK_STATUS:
    {

      if (!state.presenters.has(payload.presenterSid)) return state

      const changes = { status: payload.status }

      if (typeof payload.kind !== 'undefined') changes['kind'] = payload.kind

      const presenters = amendTracks(state, payload, changes)

      return { ...state, presenters }

    }
    case trackActionTypes.TRACK_UNATTACHED:
    {

      if (!state.presenters.has(payload.presenterSid)) return state

      const presenters = new Map(state.presenters)
      const body = presenters.get(payload.presenterSid)
      if (typeof body === 'undefined') return state

      const tracks = new Map(body.tracks)
      tracks.delete(payload.trackSid)

      presenters.set(payload.presenterSid, {
        ...body,
        tracks
      })

      return { ...state, presenters }

    }
    case DocsType.RESET_SESSION:
    {

      if (state.room === null) return { ...defaultState }

      state.room.localParticipant.videoTracks.forEach(publication => {

        const attachedElements = publication.track.detach()
        attachedElements.forEach(element => element.remove())

      })

      state.room.localParticipant.audioTracks.forEach(publication => {

        const attachedElements = publication.track.detach()
        attachedElements.forEach(element => element.remove())

      })

      return { ...defaultState }

    }
    case 'DEBUG':
    {

      console.log(payload.track.dimensions.width, payload.track.dimensions)
      return state

    }
    case actionTypes.SET_WEBCAM_ERROR:
      return { ...state, hasWebcamError: true, isFetchingRoom: false }
    case webcastActionTypes.FETCH_PUBLIC_WEBCAST_DATA_SUCCESS: {

      const gigTerminationTime = new Date(payload.data.closeTime)
      return { ...state, gigTerminationTime: gigTerminationTime.toISOString() }

    }
    case GigTypes.EXTEND_GIG_TERMINATION_SUCCESS:
      return { ...state, gigTerminationTime: payload }
    case playInTypes.SET_PLAY_IN:
      return { ...state, playIn: payload }
    case slidesTypes.SET_SLIDES:
      return { ...state, slides: payload }
    case playInTypes.REMOVE_PLAY_IN_DOC:
      return { ...state, playIn: defaultState.playIn }
    case roomTypes.SET_FOCUS:
      return { ...state, focusOn: payload }
    case roomTypes.SET_SCREENSHARE_FOCUS:
        return { ...state, screenShareFocus: payload }
    case roomTypes.UNSET_FOCUS:
      return { ...state, focusOn: defaultState.focusOn }
    case roomTypes.SET_MEDIA_TYPE_STATE:
      return { ...state, mediaType: payload }
    case roomTypes.SET_PARTICIPANT_INFORMATION:
      return { ...state, participantInformation: payload }
    case roomTypes.SET_DIALED_IN_PRESENTER:
      return { ...state, dialedInParticipants: [ ...state.dialedInParticipants, payload ] }
    case roomTypes.REMOVE_DIALED_IN_PRESENTER:
      return { ...state, dialedInParticipants: state.dialedInParticipants.filter(_BTID => _BTID !== payload) }
    case roomTypes.ADD_PARTICIPANT_TO_LOOKUP:
      return produce(state, draftState => {

        draftState.participantLookup[payload.key] = payload.value

      })
    case roomTypes.REMOVE_PARTICIPANT_FROM_LOOKUP:
      return produce(state, draftState => {

        delete draftState.participantLookup[payload]

      })
    default:
      return state

  }

}
